'use client';

import { Fragment, useState } from 'react';
import { useSacola } from '@/hooks/useSacola';
import dynamic from 'next/dynamic';
import SacolaVaziaFallback from '@/components/molecules/SacolaVazia/fallback';
import { Tamanho } from '@/components/templates/Drawer';
import ListagemItensCarrinhoFallback from '@/components/organisms/ListagemItensCarrinho/fallback';
import DrawerFallback from '@/components/templates/Drawer/fallback';
import { theme } from '@/styles/theme';
import { registrarEvento } from '@/services/googleAnalytics';
import useResumoCompraHook from '@/components/organisms/ResumoCompra/hook/useResumoCompraHook';
// import Button from '@/components/atoms/Button';
import CheckboxConcordarTermosProdutos from '../../components/molecules/CheckboxConcordarTermosProdutos';

const SacolaVazia = dynamic(
  () => import('@/components/molecules/SacolaVazia'),
  {
    ssr: false,
    loading: () => <SacolaVaziaFallback />,
  },
);

const ListagemItensCarrinho = dynamic(
  () => import('@/components/organisms/ListagemItensCarrinho'),
  {
    ssr: false,
    loading: () => <ListagemItensCarrinhoFallback />,
  },
);

const ResumoCompra = dynamic(
  () => import('@/components/organisms/ResumoCompra'),
  {
    ssr: false,
    loading: () => (
      <DrawerFallback
        style={{
          borderTopLeftRadius: theme.radius[1],
          borderTopRightRadius: theme.radius[1],
          height: 199,
          backgroundColor: theme.colors.neutral.neutral_alpha[3],
        }}
      />
    ),
  },
);

export default function SacolaMobile() {
  const { itens, recuperandoValoresSacola } = useSacola();

  const {
    valoresResumoCompra,
    // router,
    usuarioAceitouOsTermos,
    informarUsuarioAceitouTermos,
    mostrarCheckboxDosTermosDaAssinatura,
    formatarFormaPagamento,
    telaCaminhoBotaoContinuarPagamento,
    mostrarCheckboxDosTermosGiftCards,
  } = useResumoCompraHook();

  const [tamanhoDrawer, setTamanhoDrawer] = useState(0);

  function lidarMudancaTamanhoDrawer(tamanho: Tamanho) {
    setTamanhoDrawer(tamanho.height);
  }

  return (
    <Fragment>
      {itens?.length > 0 && !recuperandoValoresSacola ? (
        <ListagemItensCarrinho
          style={
            tamanhoDrawer
              ? {
                  paddingBottom: tamanhoDrawer,
                }
              : undefined
          }
          $itens={itens}
        />
      ) : (
        <Fragment>
          {recuperandoValoresSacola ? (
            <ListagemItensCarrinhoFallback />
          ) : (
            <SacolaVazia />
          )}
        </Fragment>
      )}
      <ResumoCompra
        $desabilitarBotao={!itens.length || !usuarioAceitouOsTermos}
        $botaoTelaCaminho={telaCaminhoBotaoContinuarPagamento}
        $botaoTexto="Continuar para pagamento"
        $lidarMudancaTamanhoDrawer={lidarMudancaTamanhoDrawer}
        $analyticsBotao={() => {
          formatarFormaPagamento();
          registrarEvento('cliqueContinuarParaPagamento', {});
          registrarEvento('begin_checkout', {
            currency: 'BRL',
            value: valoresResumoCompra?.valorTotal ?? 0,
            items: itens.map((itemSacola) => {
              if (itemSacola?.produto && itemSacola?.opcaoSelecionadaProduto) {
                return {
                  item_id: itemSacola?.opcaoSelecionadaProduto?.id,
                  item_brand: itemSacola?.produto?.nome,
                  item_name: itemSacola?.opcaoSelecionadaProduto?.nome,
                  discount: itemSacola?.opcaoSelecionadaProduto?.desconto,
                  quantity: itemSacola?.quantidade,
                };
              } else if (itemSacola?.plano) {
                return {
                  item_id: itemSacola.plano.comboID,
                  item_name: itemSacola.plano.nome,
                  discount: itemSacola.plano.desconto,
                };
              }
            }),
          });
        }}
        $botoesAdicionais={
          <></>
          // <Button
          //   $size={2}
          //   $variant="soft"
          //   $color="accent"
          //   $highContrast={false}
          //   $loading={false}
          //   $focusRing={false}
          //   $text="Continuar comprando"
          //   style={{
          //     justifyContent: 'center',
          //   }}
          //   $onClick={() => {
          //     registrarEvento('sacola_clicou_continuar_comprando', {});
          //     router.push('/');
          //   }}
          // />
        }
      >
        {mostrarCheckboxDosTermosDaAssinatura ||
        mostrarCheckboxDosTermosGiftCards ? (
          <CheckboxConcordarTermosProdutos
            setUsuarioAceitouTermosProdutos={informarUsuarioAceitouTermos}
            usuarioAceitouOsTermos={usuarioAceitouOsTermos}
            mostrarTermosChippu={mostrarCheckboxDosTermosGiftCards}
            mostrarTermosAssinatura={mostrarCheckboxDosTermosDaAssinatura}
          />
        ) : null}
      </ResumoCompra>
    </Fragment>
  );
}
